import Component from './Component';

export default class WeatherWidget extends Component {
  load() {
    this.initWeatherWidget();
    super.load();
  }

  initWeatherWidget() {
    // console.log("weather widget loaded.");
    $(".weather-widget").on("click", function () {
      // console.log("menu toggled.");
      $(".weather-widget--menu").toggleClass("weather-widget--menu__visible");
      $(".weather-widget--menu").toggleClass("weather-widget--menu__hidden");
      $(".weather-widget").attr("aria-expanded", function (i, attr) {
        return attr == 'true' ? 'false' : 'true'
      });
      if ($(".weather-widget--menu__visible").length) {
        $(".weather-widget--menu li").attr("tabindex", "0");
      } else {
        $(".weather-widget--menu li").removeAttr("tabindex");
      }
    });
    $(".weather-widget").on("keyup", function (e) {
      if (e.which == 13) { //Enter key pressed
        $(".weather-widget").click(); //Trigger search button click event
      }
    });

    // close 'weather-widget' if any parent elements are clicked.
    $('body').on("click keyup", function (event) {
      const KEYCODE_ESC = 27;
      // console.log(event.which);
      if (!$(event.target).closest(".weather-widget").length || (event.which == KEYCODE_ESC)) {
        if ($(".weather-widget--menu__visible").length) {
          // console.log("menu visible");
          $(".weather-widget").attr("aria-expanded", "false");
          $(".weather-widget--menu li").removeAttr("tabindex");
          // Hide the menu.
          $(".weather-widget--menu").toggleClass("weather-widget--menu__visible");
          $(".weather-widget--menu").toggleClass("weather-widget--menu__hidden");

          // if ESC was pressed return focus to weather-widget button
          if (event.key == KEYCODE_ESC) {
            $(".weather-widget").focus();
          }
        }
      }
    });

    $(".weather-widget--menu li").on("click", function () {
      triggerMenuItem($(this), getWeather);
    });

    const weatherMenuItem = ".weather-widget--menu";
    $(weatherMenuItem).on("keydown", function (event) {
      const $focused = $(':focus');
      // console.log('action keydown');
      // console.log('focused: ', $focused);
      // console.log('target: ', $(weatherMenuItem));
      // console.log('event which: ', event.which);
      // console.log('event keyCode: ', event.keyCode);
      // console.log('event key: ', event.key);
      const KEYCODE_ENTER = 13;
      const KEYCODE_SPACE = 32;
      // const KEYCODE_RIGHT = 39;
      // const KEYCODE_DOWN = 40;
      if ($focused.length == 1 && $focused.is('li')) {
        // console.log('1 focused item && is [li] element');
        if (event.keyCode == KEYCODE_ENTER || event.which == KEYCODE_SPACE) {
          // console.log('action ENTER or SPACE');
          triggerMenuItem($focused, getWeather);
        }
      }
    });

    function triggerMenuItem(weatherMenuItem, getWeather) {
      // console.log('action triggerMenuItem.');
      const station = $(weatherMenuItem).data("location");
      // console.log("clicked " + station);
      // save users choice to cookie
      document.cookie = "weather=" + station + "; max-age=15724800"; // 26 weeks (6 mths).  (604800 is 1wk)
      //  set weather to new location
      getWeather(station);
    }

    function getWeather(station) {
      if (window.weatherJson) {
        // console.log("clicked " + station);
        // console.log(window.weatherJson);
        // console.log(window.weatherJson.weather);
        window.weatherJson.weather.forEach(item => {
          if (item.loc == station) {
            // console.log(item.loc);

            const tempsSnippet =
              "<nobr>" +
              item.minTemp +
              '°<span class="dash">&ndash;</span>' +
              item.maxTemp +
              "°</nobr>";
            const tempsHtml = $.parseHTML(tempsSnippet);
            $(".temps").html(tempsHtml);

            const locationSnippet =
              station + ' <i class="far fa-angle-down" aria-hidden="true"></i>';
            const locationHtml = $.parseHTML(locationSnippet);
            $(".location").html(locationHtml);

            // console.log(item.description);
            let iconSnippet = '<img src="/static/images/i_sunny.svg" alt="clear sky" /><!-- js default -->';
            switch (item.description) {
              case "clear sky":
                iconSnippet = '<img src="/static/images/i_sunny.svg" alt="clear sky" />';
                break;

              case "few clouds":
                iconSnippet = '<img src="/static/images/i_partly_cloudy.svg" alt="few clouds" />';
                break;

              case "scattered clouds":
                iconSnippet = '<img src="/static/images/i_partly_cloudy.svg" alt="scattered clouds" />';
                break;

              case "broken clouds":
                iconSnippet = '<img src="/static/images/i_overcast.svg" alt="broken clouds" />';
                break;

              case "overcast clouds":
                iconSnippet = '<img src="/static/images/i_overcast.svg" alt="overcast clouds" />';
                break;

              case "shower rain":
                iconSnippet = '<img src="/static/images/i_light_rain.svg" alt="shower rain" />';
                break;

              case "rain":
                iconSnippet = '<img src="/static/images/i_moderate_rain.svg" alt="rain" />';
                break;

              case "thunderstorm":
                iconSnippet = '<img src="/static/images/i_thunder.svg" alt="thunderstorm" />';
                break;

              case "snow":
                iconSnippet = '<img src="/static/images/i_snow_fog.svg" alt="snow" />';
                break;

              case "mist":
                iconSnippet = '<img src="/static/images/i_light_mist.svg" alt="mist" />';
                break;
            }
            const iconHtml = $.parseHTML(iconSnippet);
            $(".weather--icon").html(iconHtml);
          }
        });
      }
    }
  }
}


